var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-dialog",
    { ref: "base", attrs: { "close-on-back": "", "max-width": "80vw" } },
    [
      _c(
        "div",
        { staticStyle: { "background-color": "#2a2a2a", color: "#f2f2f2" } },
        [
          _c("v-img", {
            attrs: { "max-height": "80vh", contain: "", src: _vm.src },
          }),
          _c(
            "v-container",
            {
              staticClass: "pa-3 caption",
              staticStyle: { background: "#222222" },
              attrs: { fluid: "" },
            },
            [
              _c(
                "v-row",
                {
                  staticStyle: { gap: "12px" },
                  attrs: { justify: "end", "no-gutters": "" },
                },
                [
                  _c(
                    "v-col",
                    { staticClass: "text-left", attrs: { cols: "auto" } },
                    [
                      _c(
                        "a",
                        {
                          staticStyle: {
                            color: "white",
                            "text-decoration": "unset",
                          },
                          attrs: { href: _vm.src, target: "_blank" },
                        },
                        [_vm._v(" Открыть оригинал ")]
                      ),
                    ]
                  ),
                  _c("v-col", { attrs: { cols: "auto" } }, [_vm._v(" · ")]),
                  _c(
                    "v-col",
                    {
                      staticClass: "d-flex align-center",
                      staticStyle: { gap: "4px" },
                      attrs: { cols: "auto" },
                    },
                    [
                      _vm.loadingSearch
                        ? _c("v-progress-circular", {
                            attrs: {
                              size: "11",
                              width: "1",
                              indeterminate: "",
                              color: "white",
                            },
                          })
                        : _vm._e(),
                      _c(
                        "a",
                        {
                          staticClass: "white--text",
                          on: { click: _vm.onSearchSimilar },
                        },
                        [_vm._v(" Найти похожие ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }